module.exports = __webpack_public_path__ + "static/media/paste-code.40f7e96c.png";